import { createFileRoute } from "@tanstack/react-router";
import { LaunchSixMillionProviders } from "@/components/press/articles/LaunchSixMillionProviders";

const SITE = "https://heallexa.com";
const URL = `${SITE}/press/launch-6m-providers`;
const TITLE =
  "Heallexa Launches AI Powered Healthcare Search Platform With a Directory of More Than 6.3 Million Provider Profiles";
const DESCRIPTION =
  "Heallexa launches an AI powered healthcare search platform with more than 6.3 million U.S. provider profiles, letting patients search by specialty, location, insurance, and availability.";
const DATE_ISO = "2026-05-30";

export const Route = createFileRoute("/press/launch-6m-providers")({
  head: () => ({
    meta: [
      { title: `${TITLE} | Heallexa` },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "article" },
      { property: "article:published_time", content: DATE_ISO },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NewsArticle",
          headline: TITLE,
          description: DESCRIPTION,
          datePublished: DATE_ISO,
          dateModified: DATE_ISO,
          url: URL,
          author: { "@type": "Organization", name: "Heallexa", url: SITE },
          publisher: {
            "@type": "Organization",
            name: "Heallexa",
            logo: { "@type": "ImageObject", url: `${SITE}/logo.png` },
          },
          mainEntityOfPage: { "@type": "WebPage", "@id": URL },
        }),
      },
    ],
  }),
  component: LaunchSixMillionProviders,
});
